export default "__VITE_ASSET__CTOV9eim__"